import { useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';

import { KimInput } from './kim-input';
import { useCreateKimThread } from '@/api/mutations/useCreateKimThread';

export function NewKimLargeInput() {
  const { matterId, subsetId } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = useState('');

  const { mutate: createThread, isLoading } = useCreateKimThread(matterId, subsetId);

  const handleSubmit = () => {
    const trimmed = question.trim();
    if (!trimmed) return;

    createThread(trimmed, {
      onSuccess: (data) => {
        navigate(`/matters/${matterId}/subsets/${subsetId}/new-kim/${data.id}`);
      },
      onError: () => {
        toast.error('Error creating thread');
      },
    });
  };

  return (
    <div className="flex w-full flex-col items-center">
      <h2 className="mb-8 font-serif text-2xl font-medium">Ask Kim...</h2>

      <KimInput
        className="min-h-32 w-full max-w-xl rounded-xl p-4 py-3"
        placeholder="What is this Matter about?"
        value={question}
        onChange={setQuestion}
        onSubmit={handleSubmit}
        disabled={isLoading}
      />
    </div>
  );
}
